/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Noorganizationcreating3Inputs */

const zh_organizationsettings_noorganizationcreating3 = /** @type {(inputs: Organizationsettings_Noorganizationcreating3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建中...`)
};

const en_organizationsettings_noorganizationcreating3 = /** @type {(inputs: Organizationsettings_Noorganizationcreating3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating...`)
};

const es_organizationsettings_noorganizationcreating3 = /** @type {(inputs: Organizationsettings_Noorganizationcreating3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando...`)
};

/**
* | output |
* | --- |
* | "Creating..." |
*
* @param {Organizationsettings_Noorganizationcreating3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_noorganizationcreating3 = /** @type {((inputs?: Organizationsettings_Noorganizationcreating3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Noorganizationcreating3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_noorganizationcreating3(inputs)
	if (locale === "en") return en_organizationsettings_noorganizationcreating3(inputs)
	return es_organizationsettings_noorganizationcreating3(inputs)
});
export { organizationsettings_noorganizationcreating3 as "organizationSettings_noOrganizationCreating" }